// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__3e8yy","header":"Page_header__3eZ4g","goback":"Page_goback__3Kmcf","action":"Page_action__1fQuB"};